import React from "react";
import { Utils } from "@common/utils";

const priceCell = (value) => {
    const formatted = Utils.formatPrice(value);
    return formatted == null ? "" : `$${formatted}`;
};

const percentCell = (value) => {
    if (value === undefined) return "";
    const sign = value > 0 ? "+" : value < 0 ? "-" : "";
    const modifier = value < 0 ? "negative" : "positive";
    return (
        <span
            className={`recommendation-products-table__pct recommendation-products-table__pct--${modifier}`}>
            {sign}
            {Math.abs(value).toLocaleString("de-DE")}%
        </span>
    );
};

const PRICE_LIKE_COLUMNS = (theirPriceField, diffField) => [
    { header: "Producto", cell: (row) => row.product },
    { header: "Tu precio", cell: (row) => priceCell(row.myPrice), modifier: "emphasis" },
    { header: "Competidor", cell: (row) => row.competitor ?? "", modifier: "muted" },
    { header: "Su precio", cell: (row) => priceCell(row[theirPriceField]), modifier: "muted" },
    { header: "Dif.", cell: (row) => percentCell(row[diffField]) },
];

const CASE_COLUMNS = {
    PRICE: PRICE_LIKE_COLUMNS("theirPrice", "diffPct"),
    STOCK: [
        { header: "Producto", cell: (row) => row.product },
        { header: "Tu precio", cell: (row) => priceCell(row.myPrice), modifier: "emphasis" },
        { header: "Competidor", cell: (row) => row.competitor ?? "", modifier: "muted" },
        { header: "Su precio", cell: (row) => priceCell(row.theirPrice), modifier: "muted" },
    ],
    MOVEMENT: PRICE_LIKE_COLUMNS("newPrice", "deltaPct"),
};

export function RecommendationProductsTable({ caseType, products }) {
    const columns = CASE_COLUMNS[caseType];

    return (
        <table
            className="recommendation-products-table"
            data-testid="recommendation-products-table">
            <thead>
                <tr>
                    {columns.map((column) => (
                        <th key={column.header}>{column.header}</th>
                    ))}
                </tr>
            </thead>
            <tbody>
                {products.map((row) => (
                    <tr key={row.sku}>
                        {columns.map((column) => (
                            <td
                                key={column.header}
                                className={
                                    column.modifier
                                        ? `recommendation-products-table__cell--${column.modifier}`
                                        : undefined
                                }>
                                {column.cell(row)}
                            </td>
                        ))}
                    </tr>
                ))}
            </tbody>
        </table>
    );
}
